module.exports = __webpack_public_path__ + "static/media/instagram.e75317fa.svg";